import classnames from 'classnames';

const className = classnames(
  'h-5',
  'self-center',
  'bg-card-border-color',
  'mx-1',
  'w-px'
);

const ActionListHeader = () => <span className={className} />;

export default ActionListHeader;
